import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import BrandLogo from '../Brand/BrandLogo';
import { notifyError, notifySuccess } from '../../utils/utils';
import { userApis } from '../../redux/api';
import './Footer.css';
import '../../styles/DarkMarketplace.scss';

const groups = [
  {
    title: 'Platform',
    links: [
      ['Marketplace', '/home'],
      ['Wallet', '/wallet'],
      ['My music', '/music'],
      ['Crowdsales', '/mycrowdsale'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['About TokenizeMe', '/aboutus'],
      ['Contact support', '/support'],
    ],
  },
  {
    title: 'Resources',
    links: [
      ['How it works', '/faq'],
      ['Music rights & royalties', '/faq#rights'],
      ['Technology & wallets', '/faq#wallets'],
      ['Help center', '/faq#help'],
      ['Privacy policy', '/privacy'],
      ['Terms of service', '/terms'],
    ],
  },
];

export default function MainFooter() {
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSubscribe = async (event) => {
    event.preventDefault();
    if (!consent || loading) return;
    try {
      setLoading(true);
      const response = await fetch(userApis.SUBSCRIBE_NEWSLETTER_PUBLIC, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
          source: 'website-footer',
        }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok)
        throw new Error(data?.message || 'Unable to subscribe right now.');
      notifySuccess(data?.message || 'Subscription confirmed.');
      setEmail('');
      setConsent(false);
    } catch (error) {
      notifyError(error?.message || 'Unable to subscribe right now.');
    } finally {
      setLoading(false);
    }
  };
  return (
    <footer className="tm-main-footer tm-dark-footer">
      <div className="tm-footer-top">
        <div className="tm-footer-brand">
          <BrandLogo />
          <p>
            Music rights. New possibilities.
            <br />
            Explore ownership opportunities in the music you believe in.
          </p>
        </div>
        {groups.map((group) => (
          <nav aria-label={group.title} key={group.title}>
            <h2>{group.title}</h2>
            <ul>
              {group.links.map(([label, to]) => (
                <li key={label}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>
      <div className="tm-footer-newsletter">
        <div>
          <h2>Stay in the loop</h2>
          <p>Music investment opportunities and platform updates.</p>
        </div>
        <form onSubmit={handleSubscribe}>
          <div className="tm-newsletter-input">
            <label className="sr-only" htmlFor="tm-newsletter-email">
              Email address
            </label>
            <input
              id="tm-newsletter-email"
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
            <button type="submit" disabled={loading || !consent}>
              {loading ? 'Subscribing…' : 'Subscribe'}
              <ArrowRight size={14} aria-hidden="true" />
            </button>
          </div>
          <label className="tm-newsletter-consent">
            <input
              type="checkbox"
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
              required
            />
            <span>
              I agree to receive updates by email.{' '}
              <Link to="/privacy">Privacy policy</Link>.
            </span>
          </label>
        </form>
      </div>
      <div className="tm-footer-bottom">
        <span>
          © {new Date().getFullYear()} TokenizeMe. All rights reserved.
        </span>
        <span>
          Music investment involves risk. Review each opportunity’s terms.
        </span>
      </div>
    </footer>
  );
}
